module.exports = __webpack_public_path__ + "media/images/smart_phone/inquiry_requests/ic_required-e4215f18a62ae5a1fcd7fe5d9fd341bc.png";